import Address from "../../types/core/Address";
import EmailAddress from "../../types/core/EmailAddress";
import PhoneNumber from "../../types/core/PhoneNumber";
import { PersonGenders } from "../enums/PersonGenders";
import Contact from "./Contact";

export enum TitleType {
    Dr = "Dr",
    Miss = "Miss",
    Mr = "Mr",
    Mrs = "Mrs",
    Ms = "Ms",
    Mstr = "Mstr",
    Mx = "Mx",
}

class Person {
    id: number;
    title: TitleType;
    firstName: string;
    lastName: string;
    middleName: string;
    preferredName: string;
    email: string;
    phone: string;
    mobile: string;
    gender: PersonGenders;
    numbers: PhoneNumber[];
    emails: EmailAddress[];
    addresses: Address[];
    contacts?: Contact[];

    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
    set fullName(_: string) {}

    get display() {
        return `${this.firstName} ${this.lastName}`;
    }

    constructor(data?: Partial<Person>) {
        Object.assign(this, data);

        this.numbers = data?.numbers?.map(item => new PhoneNumber(item)) ?? [];

        this.emails = data?.emails?.map(item => new EmailAddress(item)) ?? [];

        this.addresses = data?.addresses?.map(item => new Address(item)) ?? [];
    }
}

export default Person;
